import { useState } from 'react';
import { DenseModification, Board } from '@/types';
import {
  toggleModificationEnabled,
} from '@/services/modification.service';
import { useToast } from '@/hooks/use-toast';
import { ModificationEntryComponent } from './ModificationEntry.component';

interface ModificationEntryProps {
  modification: DenseModification;
  onDismiss?: (modificationId: string) => void;
  currentUserId?: string;
  boardOwnerId?: string;
  boardId?: string;
  board?: Board | null;
}

export const ModificationEntry: React.FC<ModificationEntryProps> = ({
  modification,
  onDismiss,
  currentUserId,
  boardOwnerId,
  boardId,
  board,
}) => {
  const { toast } = useToast();
  const [isToggling, setIsToggling] = useState(false);

  const handleToggleEnabled = async () => {
    if (!boardId || !currentUserId) return;
    
    const isBoardOwner = currentUserId === boardOwnerId;
    if (!isBoardOwner) return;

    setIsToggling(true);
    const newEnabled = !modification.enabled;
    const result = await toggleModificationEnabled(
      boardId,
      modification.id,
      currentUserId,
      newEnabled
    );

    if (result.success) {
      toast({
        title: newEnabled ? 'Modification enabled' : 'Modification disabled',
        description: `The modification has been ${newEnabled ? 'enabled' : 'disabled'}`,
      });
    } else {
      toast({
        title: 'Failed to toggle modification',
        description: result.error || 'An error occurred',
        variant: 'destructive',
      });
    }
    setIsToggling(false);
  };

  return (
    <ModificationEntryComponent
      modification={modification}
      onDismiss={onDismiss}
      currentUserId={currentUserId}
      boardOwnerId={boardOwnerId}
      boardId={boardId}
      board={board}
      isToggling={isToggling}
      onToggleEnabled={handleToggleEnabled}
    />
  );
};

